export default {
    de: {
        currencySymbol: '€',
        defaultPlaceholder: 'Betrag in EUR',
    },
};
